import { Icon } from '@chakra-ui/react';

export const CustomHelpIcon = (props) => (
  <Icon viewBox="0 0 512 512" {...props}>
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256ZM0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256ZM256 176C238.3 176 224 190.3 224 208C224 221.3 213.3 232 200 232C186.7 232 176 221.3 176 208C176 163.8 211.8 128 256 128C300.2 128 336 163.8 336 208C336 255.2 300 275.2 280 282.5V286.3C280 299.6 269.3 310.3 256 310.3C242.7 310.3 232 299.6 232 286.3V278.2C232 257.7 246.8 243 262.1 238C268.5 235.9 275.3 232.5 280.3 227.7C284.6 223.5 288 217.7 288 208.1C288 190.4 273.7 176.1 256 176.1V176ZM224 368C224 350.3 238.3 336 256 336C273.7 336 288 350.3 288 368C288 385.7 273.7 400 256 400C238.3 400 224 385.7 224 368Z"
        fill="currentColor"
      />
    </svg>
  </Icon>
);
